<form [formGroup]="form">
  <ng-container *ngIf="editMode">
    <!-- Foods -->
    <app-content-header text="Food"></app-content-header>
    <div
      class="lato teal"
      style="margin: 1.5rem 0 1.25rem"
    >Please provide feeding information for boarding stays.</div>
    <div class="input-container">
      <span class="input-label">Breakfast (Parent Provided)</span>
      <div class="row">
        <div class="col col-sm-9">
          <app-binary-choice-selector
            [opt1]="yesNoList[0]"
            [opt2]="yesNoList[1]"
            [selectedValue]="f.isBreakfast.value"
            (selectedValueChange)="f.isBreakfast.setValue($event)"
          ></app-binary-choice-selector>
        </div>
      </div>
    </div>
    <div class="input-container">
      <span class="input-label">Dinner (Parent Provided)</span>
      <div class="row">
        <div class="col col-sm-9">
          <app-binary-choice-selector
            [opt1]="yesNoList[0]"
            [opt2]="yesNoList[1]"
            [selectedValue]="f.isDinner.value"
            (selectedValueChange)="f.isDinner.setValue($event)"
          ></app-binary-choice-selector>
        </div>
      </div>
    </div>
    <div class="input-container">
      <span class="input-label">Quantities, food type and any special feeding instructions
        <span
          *ngIf="!f.isDinner.value && !f.isBreakfast.value"
        >(optional)</span>
        </span>
      <textarea
        type="text"
        class="input"
        rows="5"
        style="height: auto"
        formControlName="foodDetails"
      ></textarea>
      <span
        *ngIf="form.get('foodDetails').errors?.required"
        class="error"
      >Please enter instructions.</span>
    </div>
    <hr>
    <div class="input-container">
      <span class="input-label">Can we give your Camper a Campfire Treat&trade; at bedtime if boarding?</span>
      <div class="row">
        <div class="col col-sm-9">
          <app-binary-choice-selector
            [opt1]="yesNoList[0]"
            [opt2]="yesNoList[1]"
            [selectedValue]="f.isCampfireTreat.value"
            (selectedValueChange)="f.isCampfireTreat.setValue($event)"
          >
          </app-binary-choice-selector>
        </div>
      </div>
      <div class="row no-gutters emergency-box" *ngIf="f.isCampfireTreat.value">
        <div class="col-auto">
          <img
            src="../../../../assets/svg/ico_paw_print.svg"
            width="12"
            class="paw-print"
          />
        </div>
        <div class="col emergency-text">
          If your Camper has any food allergies, please go to Health Records in their profile to add allergy information.
        </div>
      </div>
    </div>
    <!-- Medications -->
    <div formArrayName="medicationArr">
      <app-content-header text="Medications"></app-content-header>
      <ng-container
        *ngFor="let medication of medicationFormArray.controls; let i = index;"
        [formGroupName]="i"
      >
        <div
          class="input-container d-flex pb-1"
          style="font-size: 1.25rem;"
        >
          <div style="flex: 1">
            <span class="lato bold title-red">{{ 'Medication ' + (i + 1) }}</span>
          </div>
          <div
            class="icon-container trash"
            (click)="removeMedication(i)"
            (keyup.enter)="removeMedication(i)"
            tabindex="0"
          >
            <img
              src="assets/svg/ico_trash_can.svg"
              alt="Trash Can Icon"
              width="15"
            >
          </div>
        </div>
        <div class="input-container" (click)="changeMedicationType(medication)">
          <app-medication-type-search
            [index]="i"
            [selectedMedicationTypeIds]="selectedMedicationTypeIds"
            [selectedMed]="medication.value"
            (selectFromDropdown)="handleMedTypeChange($event)"></app-medication-type-search>
          <span
            class="error"
            *ngIf="medication.value.attributeId === null"
          >Please select a medication type.</span>
        </div>
        <div class="input-container">
          <span class="input-label">Medication Times: Morning</span>
          <div class="row">
            <div class="col col-sm-9">
              <app-binary-choice-selector
                [opt1]="yesNoList[0]"
                [opt2]="yesNoList[1]"
                [selectedValue]="medication.get('isMorning').value"
                (selectedValueChange)="medication.get('isMorning').setValue($event)"
              ></app-binary-choice-selector>
            </div>
          </div>
        </div>
        <div class="input-container">
          <span class="input-label">Medication Times: Evening</span>
          <div class="row">
            <div class="col col-sm-9">
              <app-binary-choice-selector
                [opt1]="yesNoList[0]"
                [opt2]="yesNoList[1]"
                [selectedValue]="medication.get('isEvening').value"
                (selectedValueChange)="medication.get('isEvening').setValue($event)"
              ></app-binary-choice-selector>
            </div>
          </div>
        </div>
        <div class="input-container">
          <span class="input-label">Medication name, dosage and other care instructions
             <span
               *ngIf="!medication.get('isEvening').value && !medication.get('isMorning').value"
             >(optional)</span>
          </span>
          <textarea
            type="text"
            class="input"
            rows="5"
            style="height: auto"
            formControlName="medDetails"
          ></textarea>
          <span
            *ngIf="medication.get('medDetails').errors?.required"
            class="error"
          >Please enter instructions.</span>
        </div>
        <hr>
      </ng-container>
      <app-arrow-link-right
        text="+ Add a Medication"
        (handleClick)="addMedication()"
        (keyup.enter)="addMedication()"
      ></app-arrow-link-right>
    </div>
    <div style="margin-top: 5rem;">
      <hr>
      <footer class="footer-action">
        <button
          type="button"
          class="btn btn-danger btn-block"
          [disabled]="!form.valid"
          (click)="onSave()"
        >Save</button>
      </footer>
    </div>
  </ng-container>

  <ng-container *ngIf="!editMode">
    <!-- Foods -->
    <app-content-header
      text="Food"
      [showEdit]="true"
      (editClicked)="enterEditMode()"
      firebase="dogProfile_editFood"
    >
    </app-content-header>
    <div class="row">
      <div class="col view-container">
        <div class="view-label">Breakfast (Parent Provided)</div>
        <span>{{ getYesNoText(f.isBreakfast.value) }}</span>
        <hr class="view-divider" />
      </div>
    </div>
    <div class="row">
      <div class="col view-container">
        <div class="view-label">Dinner (Parent Provided)</div>
        <span>{{ getYesNoText(f.isDinner.value) }}</span>
        <hr class="view-divider" />
      </div>
    </div>
    <div class="row">
      <div class="col view-container">
        <div class="view-label">Quantities, food type and any special feeding instructions</div>
        <span>{{ f.foodDetails.value }}</span>
        <hr class="view-divider" />
      </div>
    </div>
    <div class="row mb-4">
      <div class="col view-container">
        <div class="view-label">Nighttime Campfire Treat&trade;</div>
        <span>{{ getYesNoText(f.isCampfireTreat.value) }}</span>
        <hr class="view-divider" />
      </div>
    </div>
    <!-- Medications -->
    <app-content-header
      text="Medications"
      [showEdit]="true"
      (editClicked)="enterEditMode()"
      firebase="dogProfile_editMedication"
    ></app-content-header>
    <span
      *ngIf="medicationFormArray.length === 0"
      class="lato"
    >No records found.</span>
    <ng-container *ngFor="let medication of medicationFormArray.controls; let i = index;">
      <span class="lato bold title-red">{{ 'Medication ' + (i + 1) }}</span>
      <div class="row">
        <div class="col view-container">
          <div class="view-label">Medication Type</div>
          <span>{{ medication.get('name').value ? medication.get('name').value : 'N/A' }}</span>
          <hr class="view-divider" />
        </div>
      </div>
      <div class="row">
        <div class="col view-container">
          <div class="view-label">Medication Times: Morning</div>
          <span>{{ getYesNoText(medication.get('isMorning').value) }}</span>
          <hr class="view-divider" />
        </div>
      </div>
      <div class="row">
        <div class="col view-container">
          <div class="view-label">Medication Times: Evening</div>
          <span>{{ getYesNoText(medication.get('isEvening').value) }}</span>
          <hr class="view-divider" />
        </div>
      </div>
      <div class="row">
        <div class="col view-container">
          <div class="view-label">Medication name, dosage and other care instructions</div>
          <span>{{ medication.get('medDetails').value ? medication.get('medDetails').value : 'N/A' }}</span>
          <hr class="view-divider" />
        </div>
      </div>
    </ng-container>
  </ng-container>
</form>
